import React from 'react'

const config = {
  "navAnchor": "left",
  "navVariant": {
    "xs": "temporary",
    "sm": "persistent",
    "md": "persistent"
  },
  "navWidth": {
    "xs": 240,
    "sm": 256,
    "md": 256
  },
  "collapsible": {
    "xs": true,
    "sm": true,
    "md": true
  },
  "collapsedWidth": {
    "xs": 64,
    "sm": 64,
    "md": 64
  },
  "clipped": {
    "xs": true,
    "sm": false,
    "md": false
  },
  "headerPosition": {
    "xs": "static",
    "sm": "static",
    "md": "static"
  },
  "squeezed": {
    "xs": true,
    "sm": true,
    "md": true
  },
  "footerShrink": {
    "xs": true,
    "sm": true,
    "md": true
  }
};

export default config
